import { useProgress } from "@react-three/drei";
import { useEffect, useRef, useState } from "react";
import GyroActivatorIOS from "./tools/GyroActivatorIOS";
import { useFakeProgress } from "./hook/useFakeProgress";

export default function LoaderScreen() {
    const { percent, done } = useFakeProgress({ slowMs: 100, fastMs: 50, minMs: 800 })

    return (
        <>

            <div className={done ? 'loading-screen-container unactive' : 'loading-screen-container'}>
                <div className="loading-screen-container-anim">
                    <img src="./img/loader/maestr.png" className="maestr" />
                    <img src="./img/loader/accolade.png" className={done ? 'unactive accolade gauche' : 'accolade gauche'} />
                    <div className={done ? 'loading-screen-count active' : 'loading-screen-count'}>
                        <div className={done ? 'progress-wrap unactive' : 'progress-wrap'}>
                            <p className={done ? 'unactive f36 progress red' : 'f36 progress red'}>
                                {percent}%
                            </p>
                        </div>
                        <img className={done ? 'active logo' : 'logo'} src="./img/loader/spiral.png" alt="" />
                    </div>
                    <img src="./img/loader/accolade.png" className={done ? 'unactive accolade droite' : 'accolade droite'} />
                    <img src="./img/loader/m.png" className="m" />
                </div>
            </div>
            {done && <GyroActivatorIOS />}
        </>
    )

}